import LightCode from "./light-code.js";

export default LightCode;

LightCode.define();
